import { QueryStatus, useQuery } from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import {
  GetUserProgramInstituteCoursesRequestObjectSchema,
  GetUserProgramInstituteCoursesResponseSchema,
  GetUserProgramInstituteCoursesResponseType
} from '../../../services/PaymentServices/APIService/types';

import usePaymentServices from '../usePaymentServices';

interface UseGetUserProgramInstituteCoursesApiInterface {
  data: GetUserProgramInstituteCoursesResponseType | undefined;
  isLoading: boolean;
  isError: boolean;
  error: string | null;
  status: QueryStatus;
  refetch: () => Promise<any>;
  isFetching: boolean;
}

const useGetUserProgramInstituteCoursesApi = (
  programId: number,
  enabled: boolean = true
): UseGetUserProgramInstituteCoursesApiInterface => {
  const { paymentServices } = usePaymentServices();

  const getUserProgramInstituteCourses = () => {
    const requestObject = { program_id: programId };
    try {
      GetUserProgramInstituteCoursesRequestObjectSchema.parse(requestObject);
    } catch (error) {
      console.error('Invalid request object:', error);
      throw error;
    }

    return paymentServices
      .getUserProgramInstituteCourses(requestObject)
      .then((response) => {
        try {
          GetUserProgramInstituteCoursesResponseSchema.parse(response);
        } catch (error) {
          console.error('Invalid response object:', error);
          throw error;
        }
        return response;
      });
  };

  const { data, isLoading, isError, error, status, refetch, isFetching } =
    useQuery(
      ['getUserProgramInstituteCourses', programId],
      getUserProgramInstituteCourses,
      {
        enabled: Boolean(programId) && enabled,
        staleTime: 30000
      }
    );

  return {
    data,
    isLoading,
    isError,
    error: error ? getAPIErrorMessage(error) : null,
    status,
    refetch,
    isFetching
  };
};

export { useGetUserProgramInstituteCoursesApi };
